<div class="p-3">
  <div
    *ngIf="step !== WelcomeSystemStepEnum.GREETINGS"
    class="flex gap-3"
    [ngClass]="{
      'justify-content-between': step !== WelcomeSystemStepEnum.IMPORT_SELECTION_TYPE,
      'justify-content-end': step === WelcomeSystemStepEnum.IMPORT_SELECTION_TYPE
    }">
    <button
      *ngIf="step !== WelcomeSystemStepEnum.IMPORT_SELECTION_TYPE"
      pButton
      type="button"
      icon="pi pi-arrow-left"
      class="p-button-rounded p-button-secondary p-button-text"
      (click)="clickBack()"></button>
    <button
      *ngIf="showClose"
      pButton
      type="button"
      icon="pi pi-times"
      class="p-button-rounded p-button-secondary p-button-text"
      (click)="closeModal()"></button>
  </div>

  <ng-container [ngSwitch]="step">
    <ng-container *ngSwitchCase="WelcomeSystemStepEnum.GREETINGS">
      <div
        class="px-3"
        style="padding-top: 10rem; padding-bottom: 10rem">
        <p class="font-bold text-3xl mb-3">Добро пожаловать в ФРМ!</p>
        <p class="font-medium text-2xl">Мы рады, что вы решили воспользоваться бесплатным периодом!</p>
        <p class="font-medium text-2xl">
          Надеемся, что в ФРМ вы найдете полезные инструменты для оптимизации своего бизнеса.
        </p>

        <div class="flex justify-content-center mt-6">
          <button
            pButton
            type="button"
            label="Далее"
            icon="pi pi-arrow-right"
            iconPos="right"
            class="p-button-success p-button-lg"
            (click)="step = WelcomeSystemStepEnum.IMPORT_SELECTION_TYPE"></button>
        </div>
      </div>
    </ng-container>
    <crm-welcome-system-import-selection-type
      *ngSwitchCase="WelcomeSystemStepEnum.IMPORT_SELECTION_TYPE"
      (stepChange)="changeStep($event)"
      (onShowClose)="showClose = $event"
      (closeModal)="closeModal($event)"></crm-welcome-system-import-selection-type>
    <crm-welcome-system-select-bank
      *ngSwitchCase="WelcomeSystemStepEnum.IMPORT_SELECTION_BANK"
      (selectBank)="selectBank($event)"></crm-welcome-system-select-bank>
    <crm-welcome-system-info-import
      *ngSwitchDefault
      [step]="step"
      [bank]="selectedBank"
      (closeModal)="closeModal()"></crm-welcome-system-info-import>
  </ng-container>
</div>
